import React, { useState, useEffect } from 'react';
import AuthCard from './AuthCard';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { authService } from '../../services/api';
import { CircularProgress } from '@mui/material';

const SelfSignupCheckEmail = ({ email, logoUrl, onClosed }) => {
    const [status, setStatus] = useState('success'); // 'loading'
    const [errorMsg, setErrorMsg] = useState('');
    const handleResendMagicLink = async () => {
        setStatus('loading');
        setErrorMsg('');
        // A refusal or a failed send shows its message on this card (S-14, S-19 (f)). Removed 18 Oct 2026 (S-14): waiting
        // with no error handling, so a refusal left "Sending magic link..." on the page for good.
        try {
            await authService.selfSignupEmail(email);
        } catch (error) {
            // Sign-ups closed since the first send (self-signup switched off, or the cap reached, N47 pt 3): the page's
            // 'Signups are currently closed' screen, as the first send shows. Removed 2 Nov 2026 (N47 pt 3): its message
            // as a line on this card.
            if (error.response?.data?.signupsClosed && onClosed) {
                onClosed();
                return;
            }
            setErrorMsg(error.response?.data?.message || 'Failed to resend magic link');
        }
        setStatus('success');
    };

    /* ────── Loading view ────── */
    if (status === 'loading') {
        return (
        <AuthCard logoUrl={logoUrl}>
            <div className="ac-body" style={{ textAlign: 'center', padding: '40px 0' }}>
                <CircularProgress />
                <div className="ac-title" style={{ marginTop: '20px' }}>Sending magic link...</div>
            </div>
            <div className="ac-footer" />
        </AuthCard>
        );
    }
    else 
    {
        return (
            <AuthCard logoUrl={logoUrl}>
            <div className="ac-body">
                <div className="ac-icon ac-icon-success">
                    <span style={{ fontSize: '24px' }}><EmailOutlinedIcon /></span>
                </div>            
                <div className="ac-top">
                    <div className="ac-title">Check your email</div>
                    <div className="ac-sub">We sent a magic link to your email  <strong>{email}</strong>. Click it to sign in — it expires in 15 minutes.</div>
                </div>
                <div className="ac-hint">
                    Didn’t receive it? <Link className="ac-link" onClick={handleResendMagicLink}> Resend</Link>.
                </div>
                {/* A refused or failed Resend (S-14, S-19 (f)). */}
                {errorMsg && <div className="ac-field-err" style={{ textAlign: 'center' }}>{errorMsg}</div>}
            </div>
            <div className="ac-footer" />
            </AuthCard>
        );
    }
};

export default SelfSignupCheckEmail;